<template>
	<footer class="main-footer">
		<div class="copy-right">
			Copyright©2025 汲悟科技版权所有 | <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{beian}}</a> | <a href="https://news.gwotech.com/" target="_blank">吉物跨境</a>
		</div>
	</footer>
</template>

<script>
	export default {
		data() {
			return {
				beian: process.env.VUE_APP_BEIAN
			}
		}
	}
</script>

<style lang="scss" scoped>
	$mobile: 768px;
	.main-footer {
		height: 100px;
		background-color: #000;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-end;
		padding-bottom: 20px;
		.copy-right {
			color: lightgray;
			font-size: 12px;
			a {
				color: lightgray;
			}
			a:hover {
				text-decoration: none;
			}
		}
	}
	@media screen and (max-width: $mobile) {
		.main-footer {
			.copy-right {
				font-size: 10px;
			}
		}
	}
</style>